import { PackModel } from '../models/pack.model';
import { ApiService } from './api.service';
import { Injectable } from '@angular/core';
import { ArticleModel } from '../models/article.model';
import { EarticleType } from '../utils/enum.util';
import { Estate } from '../utils/enum.util';

@Injectable()
export class PackService {

    private antiRebound = 200;
    private timestamp   = 0;
    packList: PackModel[] = [];

    constructor(public apiService: ApiService) {

    }

    loadAll(parentIsInvoice: boolean = true) {
        this.apiService.get('packs', '').subscribe(res=> {
            if (this.packList.length)
                this.packList.length = 0;
            let tmp: PackModel;
            let article: ArticleModel;
            res.data.forEach((e)=> {
                tmp          = new PackModel(this);
                tmp.id       = e._id;
                tmp.name     = e.name;
                tmp.articles = [];
                e.articles.forEach((a)=> {
                    if (!parentIsInvoice)
                        article = new ArticleModel(tmp);
                    else
                        article = new ArticleModel(null);
                    article.quantity = a.quantity;
                    article.free     = a.free;
                    article.about    = a.about;
                    article.price    = a.price;
                    if (a.type == 'accessory') {
                        article.type = EarticleType.Accessory;
                    }
                    if (a.type == 'service') {
                        article.type = EarticleType.Service;
                    }
                    if (a.type == 'bike') {
                        article.type = EarticleType.Bike;
                    }
                    tmp.articles.push(article);
                });
                this.packList.unshift(tmp);
            });
        }, (_err) => {
            this.apiService.error(_err);
        });
    }

    generateData(pack: PackModel) {
        let articles: any = [];
        let article: any  = {};

        pack.articles.forEach((a)=> {
            article = {
                'type'    : a.getTypeText(),
                'price'   : '0',
                'free'    : a.free.toString(),
                'quantity': a.quantity.toString(),
                'about'   : a.about
            };
            if (a.price){
                article.price = a.price.toString();
            }

            /*if (a.getTypeText() == 'bike') {
                article.brand  = a.brand;
                article.model  = a.model;
                article.numCad = a.numCad;
            }*/

            articles.push(article);
        });

        let data: any = {
            'name'    : pack.name,
            'articles': articles
        };

        if (pack.id) {
            data.privateId = pack.id;
        }

        return data;
    }

    update(pack: PackModel) {
        //antiRebounce
        this.timestamp = new Date().getTime();
        setTimeout(()=> {
            if (this.timestamp + this.antiRebound <= new Date().getTime()) {
                this.apiService.put('pack', this.generateData(pack)).subscribe((_res) => {
                    pack.state = Estate.Save;
                }, (_err) => {
                    this.apiService.error(_err);
                    pack.state = Estate.Error;
                });
            }
        }, this.antiRebound);
    }

    create(pack: PackModel) {
        //antiRebounce
        this.timestamp = new Date().getTime();
        setTimeout(()=> {
            if (this.timestamp + this.antiRebound <= new Date().getTime()) {
                this.apiService.post('pack', this.generateData(pack)).subscribe((_res) => {
                    pack.id = _res.data.privateId;
                    this.packList.unshift(pack);
                    pack.state = Estate.Save;
                }, (_err) => {
                    this.apiService.error(_err);
                    pack.state = Estate.Error;
                });
            }
        }, this.antiRebound);
    }

    delete(pack: PackModel) {
        let data = {privateId: pack.id};
        this.apiService.delete('pack', data).subscribe((_res) => {
            this.loadAll(false);
        }, (_err) => {
            this.apiService.error(_err);
        });
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/home/services/pack.service.ts